import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a055248f6558f00140dc9da/jobcompanion/src/app/sign-up-login-screen/components/AuthForm.tsx");
